export * from "./date";
export * from "./prefectures";
export * from "./companies";
export * from "./facilities";

export const DEFAULT_LIMIT = 50;

export const MANUAL_LINK =
  "https://succulent-cell-547.notion.site/_-a48448fea24141efb2032b0c7b10e75a?pvs=4";

export const CONTACT_LINK = "https://lp.famicare.jp/contact-support-search";
